<template>
  <ul class="partner-list">
    <slot/>
  </ul>
</template>

<script>
export default {
  name: 'PartnerList',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.partner-list {
  font-family: 'Montserrat';
  font-size: 18px;
  line-height: 28px;
  @include mobile{
    font-size: 16px;
  }
  :deep {
    & > * {
      display: grid;
      grid-template-columns: 24px 1fr;
      grid-column-gap: 16px;
      list-style: none;

      &:not(:last-child) {
        margin-bottom: 31px;
        @include mobile{
          margin-bottom: 24px;
        }
      }

      &:before {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        background-image: url("/local/templates/main/images/partner/partner-icon.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }

    b {
      font-weight: 600;
    }
  }
}
</style>